import { render } from "./PostJob.vue?vue&type=template&id=e76c9940&scoped=true"
import script from "./PostJob.vue?vue&type=script&lang=js"
export * from "./PostJob.vue?vue&type=script&lang=js"

import "./PostJob.vue?vue&type=style&index=0&id=e76c9940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e76c9940"]])

export default __exports__